"use client";

import debounce from "lodash.debounce";
import { useTheme } from "next-themes";
import { useCallback, useEffect, useMemo, useRef } from "react";
import { Hotkey } from "../Hotkey";
import { User } from "~/modules/user/store/types";

// // // //

export function ThemeToggleHotkey(props: { user: User }) {
    const { user } = props;
    const { setTheme, theme } = useTheme();
    const themeRef = useRef(theme);
    themeRef.current = theme;

    const debouncedToggleTheme = useMemo(
        () =>
            debounce(() => {
                setTheme(themeRef.current === "dark" ? "light" : "dark");
            }, 300),
        [setTheme],
    );

    useEffect(() => {
        return () => {
            debouncedToggleTheme.cancel();
        };
    }, [debouncedToggleTheme]);

    const handleKeyDown = useCallback(() => {
        debouncedToggleTheme();
    }, [debouncedToggleTheme]);

    if (user.role !== "SUPERADMIN") {
        return null;
    }

    return <Hotkey keyName="ctrl+shift+l" onKeyDown={handleKeyDown} />;
}
